jQuery(document).ready(function ($) {
  // Facturation pour entreprise
  function updateCompanyFieldsVisibility() {
    var $checkbox = $('#billing_is_company');
    var isCompany = $checkbox.prop('checked');

    $('.woocommerce-checkout').toggleClass('has-company-billing', isCompany);

    console.log('Company billing fields visibility updated');
  }

  updateCompanyFieldsVisibility();

  $(document).on('change', '#billing_is_company', function () {
    updateCompanyFieldsVisibility();
  });

  $(document.body).on('updated_checkout', function () {
    updateCompanyFieldsVisibility();
  });

  /***********************************************************
   ************************ menu burger **************************
   ***********************************************************/
  $('header .hamburger').on('click', function (e) {
    $(this).toggleClass('is-active');
    $('header .logo-container').toggleClass('menu-opened');
    $('.menu-mobile').toggleClass('active');
    $('header').toggleClass('menu-opened');
  });

  $('.menu-mobile .menu .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-open');
    const $submenu = $(this).next('.sub-menu');
    $submenu.toggleClass('open');
  });

  $('.menu-mobile .menu .menu-item-has-children .sub-menu li a').on('click', function (e) {
    e.stopPropagation();
  });


  const root = document.documentElement;
  const header = $('header:visible');
  let headerH = 0;

  function getAnchorOffset() {
    return ($('header:visible').first().outerHeight() || 0)
      + ($('#wpadminbar:visible').outerHeight() || 0);
  }

  function setHeaderCssVariables() {
    root.style.setProperty('scroll-padding-top', getAnchorOffset() + 'px');

    setTimeout(function () {
      headerH = header.outerHeight() || 0;
      root.style.setProperty('--header-h', headerH + 'px');
      root.style.setProperty('scroll-padding-top', getAnchorOffset() + 'px');
    }, 230);
  }

  setHeaderCssVariables();

  $(window).on('resize load', function () {
    setHeaderCssVariables();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        setHeaderCssVariables();
      }
    });
  });

  if (header.length) {
    observer.observe(header[0], {attributes: true});
  }

  // Elementor handles its own anchor animation, bypassing native scroll padding.
  let anchorOffsetRegistered = false;

  function registerElementorAnchorOffset() {
    if (anchorOffsetRegistered || !window.elementorFrontend || !window.elementorFrontend.hooks) {
      return;
    }

    window.elementorFrontend.hooks.addFilter(
      'frontend/handlers/menu_anchor/scroll_top_distance',
      function (scrollTop) {
        // Elementor already subtracts the WordPress admin bar.
        return Math.max(0, scrollTop - ($('header:visible').first().outerHeight() || 0));
      }
    );
    anchorOffsetRegistered = true;
  }

  $(window).on('elementor/frontend/init', registerElementorAnchorOffset);
  registerElementorAnchorOffset();

  $('.scroll-arrow').on('click', function () {
    var $currentParent = $(this).closest('.e-parent');
    var $nextParent = $currentParent.nextAll('.e-parent').first();

    if ($nextParent.length) {
      $('html, body').animate({
        scrollTop: Math.max(0, $nextParent.offset().top - getAnchorOffset())
      }, 800);
    }
  });


  function closeHeaderSearch() {
    $('.header-search').removeClass('opened');
  }

  $('header .search-opener').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $headerSearch = $('.header-search');

    $headerSearch.toggleClass('opened');

    if ($headerSearch.hasClass('opened')) {
      $headerSearch.find('input').focus();
    }
  });

  $('header .search-closer').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeHeaderSearch();
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.header-search, header .search-opener').length) {
      closeHeaderSearch();
    }
  });


  // Main menu
  const $desktopMenuItems = $('.main-menu-container > ul > li.menu-item-has-children');
  let lastPointerType = '';

  $(document).on('pointerdown.desktopMenuTouch', function (e) {
    lastPointerType = e.originalEvent && e.originalEvent.pointerType
      ? e.originalEvent.pointerType
      : '';
  });

  $(document).on('touchstart.desktopMenuTouch', function () {
    lastPointerType = 'touch';
  });

  function isTouchMenuInteraction() {
    return lastPointerType === 'touch' || lastPointerType === 'pen';
  }

  function setDesktopSubmenuOpen($menuItem, isOpen) {
    const $submenu = $menuItem.children('.sub-menu-depth-1').first();
    const $link = $menuItem.children('a').first();

    if (!$submenu.length) return;

    const hadTouchState = $menuItem.hasClass('is-touch-open') || $menuItem.hasClass('is-touch-closed');

    $menuItem
      .toggleClass('is-touch-open', isOpen)
      .toggleClass('is-touch-closed', !isOpen && hadTouchState);
    $submenu
      .toggleClass('visible', isOpen)
      .css({
        visibility: isOpen ? 'visible' : (hadTouchState ? 'hidden' : ''),
        opacity: isOpen ? '1' : (hadTouchState ? '0' : '')
      });

    if ($link.length) {
      $link.attr('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function closeDesktopSubmenus($exceptMenuItem) {
    $desktopMenuItems.each(function () {
      const $menuItem = $(this);

      if (!$exceptMenuItem || !$menuItem.is($exceptMenuItem)) {
        setDesktopSubmenuOpen($menuItem, false);
      }
    });
  }

  $desktopMenuItems.each(function () {
    const $menuItem = $(this);
    const $submenu = $menuItem.children('.sub-menu-depth-1').first();
    const $link = $menuItem.children('a').first();

    if (!$submenu.length || !$link.length) return;

    $link.attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });

    $link.on('click.desktopMenuTouch', function (e) {
      if (!isTouchMenuInteraction()) return;

      e.preventDefault();
      e.stopPropagation();

      const isOpen = $menuItem.hasClass('is-touch-open');
      closeDesktopSubmenus($menuItem);
      setDesktopSubmenuOpen($menuItem, !isOpen);
    });
  });

  $desktopMenuItems.on('pointerenter.desktopMenuTouch', function (e) {
    const pointerType = e.originalEvent && e.originalEvent.pointerType
      ? e.originalEvent.pointerType
      : '';

    if (pointerType !== 'mouse') return;

    $(this)
      .removeClass('is-touch-open is-touch-closed')
      .children('.sub-menu-depth-1')
      .first()
      .removeClass('visible')
      .css({
        visibility: '',
        opacity: ''
      });
  });

  $(document).on('click.desktopMenuTouch', function (e) {
    if (!$(e.target).closest('.main-menu-container').length) {
      closeDesktopSubmenus();
    }
  });

  $(window).on('resize.desktopMenuTouch', function () {
    closeDesktopSubmenus();
  });

  $('.sessions-tabs .tab-head .tab-link').on('click', function (e) {
    e.preventDefault();

    var target = $(this).attr('href');

    $('.sessions-tabs .tab-head .tab-link').removeClass('active');
    $('.sessions-tabs .tab-head li').removeClass('active');

    $(this).addClass('active');
    $(this).parent('li').addClass('active');

    $('.tab-body').hide();
    $(target).fadeIn(200);
  });
  $('.sessions-tabs .tab-head .tab-link').first().trigger('click');

  const isHome = $('body').hasClass('home');

  if (!isHome) {
    $('header').addClass('sticky');
  }

  $('.li-tabs').on('click', function () {
    var tab = $(this).data('tab');

    $('.li-tabs').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $('#' + tab).addClass('active');
  });

  // FORMATIONS ONGLETS
  $(document).on('click', '.e-n-tab-title', function () {

    var $tab = $(this);
    var tabIndex = $tab.data('tab-index');

    var newUrl = new URL(window.location.href);
    newUrl.searchParams.set('tab', tabIndex);
    history.replaceState({}, '', newUrl);

    var $tabsWrapper = $tab.closest('.e-n-tabs');

    setTimeout(function () {
      var headerHeight = $('header').outerHeight() || 0;
      var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
      var scrollTarget = $tabsWrapper.offset().top - headerHeight - adminBarHeight - 20;

      $('html, body').stop().animate({
        scrollTop: scrollTarget
      }, 400);
    }, 100);

  });

  $(document).on('click', 'a[href*="?tab="]', function (e) {

    var targetUrl = new URL(this.href);
    var currentUrl = new URL(window.location.href);

    // Same page?
    if (
      targetUrl.origin === currentUrl.origin &&
      targetUrl.pathname === currentUrl.pathname
    ) {
      e.preventDefault();

      var tabIndex = targetUrl.searchParams.get('tab');
      var $targetTab = $('.e-n-tab-title[data-tab-index="' + tabIndex + '"]');

      if ($targetTab.length) {
        $targetTab[0].click();

        var headerHeight = $('header').outerHeight() || 0;
        var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
        var scrollTarget = $('.e-n-tabs').first().offset().top - headerHeight - adminBarHeight - 20;

        $('html, body').animate({
          scrollTop: scrollTarget
        }, 400);

        history.replaceState({}, '', targetUrl.href);
      }
    }
  });

  function openTabFromUrl() {
    var tabIndex = new URLSearchParams(window.location.search).get('tab');

    if (!tabIndex) {
      return;
    }

    var $tabsWrapper = $('.e-n-tabs').first();
    var $targetTab = $tabsWrapper.find('.e-n-tab-title[data-tab-index="' + tabIndex + '"]');

    if (!$targetTab.length) {
      return;
    }

    $targetTab[0].click();

    var headerHeight = $('header').outerHeight() || 0;
    var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
    var scrollTarget = $tabsWrapper.offset().top - headerHeight - adminBarHeight - 20;

    $('html, body').animate({
      scrollTop: scrollTarget
    }, 400);
  }

  setTimeout(openTabFromUrl, 300);
  setTimeout(openTabFromUrl, 800);
  $(window).on('load', function () {
    setTimeout(openTabFromUrl, 300);
  });

  /**
   * Sticky nav
   */
  var getStickyTabsPlaceholder = function ($tabs) {
    var $placeholder = $tabs.data('stickyPlaceholder');

    if (!$placeholder) {
      $placeholder = $('<div class="e-n-tabs-heading-placeholder" aria-hidden="true"></div>').hide();
      $tabs.after($placeholder);
      $tabs.data('stickyPlaceholder', $placeholder);
    }

    return $placeholder;
  };

  var getStickyTabsOffset = function ($tabs, $placeholder) {
    var tabsOffset = $tabs.data('stickyOffset');

    if (tabsOffset == null) {
      tabsOffset = ($tabs.hasClass('is-sticky') ? $placeholder : $tabs).offset().top;
      $tabs.data('stickyOffset', tabsOffset);
    }

    return tabsOffset;
  };

  var resetStickyTabsOffsets = function () {
    $('.e-n-tabs-heading').each(function () {
      var $tabs = $(this);
      var $placeholder = $tabs.data('stickyPlaceholder');

      $tabs.removeData('stickyOffset');

      if ($placeholder && $tabs.hasClass('is-sticky')) {
        $placeholder.height($tabs.outerHeight(true)).show();
      }
    });
  };

  var stickyNav = function () {
    var scrollTop = $(window).scrollTop();
    var $header = $('header');
    var hasStickyTabs = false;

    if (isHome) {
      if (scrollTop > 50) {
        $header.addClass('sticky');
      } else {
        $header.removeClass('sticky');
      }
    }

    var headerHeight = $header.outerHeight();
    var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;

    $('.e-n-tabs-heading').each(function () {
      var $tabs = $(this);
      var $placeholder = getStickyTabsPlaceholder($tabs);

      if (!$tabs.is(':visible')) {
        $tabs.removeClass('is-sticky').css('top', '');
        $placeholder.hide().height(0);
        return;
      }

      var tabsOffset = getStickyTabsOffset($tabs, $placeholder);

      if (scrollTop >= tabsOffset - headerHeight - adminBarHeight) {
        $tabs.addClass('is-sticky')
          .css('top', (headerHeight + adminBarHeight) + 'px');
        $placeholder.height($tabs.outerHeight(true)).show();
        hasStickyTabs = true;
      } else {
        $tabs.removeClass('is-sticky').css('top', '');
        $placeholder.hide().height(0);
      }
    });

    $('body').toggleClass('tabs-are-sticky', hasStickyTabs);
  };

  var stickyNavFrame = null;
  var requestStickyNavFrame = window.requestAnimationFrame || function (callback) {
    return setTimeout(callback, 16);
  };
  var requestStickyNav = function () {
    if (stickyNavFrame) {
      return;
    }

    stickyNavFrame = requestStickyNavFrame(function () {
      stickyNavFrame = null;
      stickyNav();
    });
  };

  stickyNav();
  $(window).on('scroll', requestStickyNav);
  $(window).on('resize load', function () {
    resetStickyTabsOffsets();
    requestStickyNav();
  });

  $(window).on('scroll', function () {
    var scrollTop = $(window).scrollTop();
    var $header = $('header');

    if (scrollTop === 0) {
      $header.addClass('at-top');
    } else {
      $header.removeClass('at-top');
    }

  });

  // Checkout connexion au compte mot de passe
  var eye = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3 9.49999C15 4.89999 8.50002 3.79999 3.90002 7.19999C2.70002 8.09999 1.70002 9.29999 0.900024 10.6C1.10002 11 1.40002 11.4 1.70002 11.8C5.00002 16.4 11.3 17.4 15.9 14.2C16.8 13.5 17.6 12.8 18.3 11.8C18.6 11.4 18.8 11 19.1 10.6C18.8 10.2 18.6 9.79999 18.3 9.49999ZM10.1 7.19999C10.6 6.69999 11.4 6.69999 11.9 7.19999C12.4 7.69999 12.4 8.49999 11.9 8.99999C11.4 9.49999 10.6 9.49999 10.1 8.99999C9.60003 8.49999 9.60003 7.69999 10.1 7.19999ZM10 14.9C6.90002 14.9 4.00002 13.3 2.30002 10.7C3.50002 8.99999 5.10002 7.79999 7.00002 7.19999C6.30002 7.99999 6.00002 8.89999 6.00002 9.89999C6.00002 12.1 7.70002 14 10 14C12.2 14 14.1 12.3 14.1 9.99999V9.89999C14.1 8.89999 13.7 7.89999 13 7.19999C14.9 7.79999 16.5 8.99999 17.7 10.7C16 13.3 13.1 14.9 10 14.9Z" fill="#111111"/>
</svg>`;

  var eyeSlash = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.3 3.3C16.9 2.9 16.2 2.9 15.7 3.3L13.3 5.7C12.2437 5.3079 11.1267 5.1048 10 5.1C6.2 5.2 2.8 7.2 1 10.5C1.2 10.9 1.5 11.3 1.8 11.7C2.6 12.8 3.6 13.7 4.7 14.4L3 16.1C2.6 16.5 2.5 17.2 3 17.7C3.4 18.1 4.1 18.2 4.6 17.7L17.3 4.9C17.7 4.4 17.7 3.7 17.3 3.3ZM6.7 12.3L5.4 13.6C4.2 12.9 3.1 11.9 2.3 10.7C3.5 9 5.1 7.8 7 7.2C5.7 8.6 5.6 10.8 6.7 12.3ZM10.1 9C9.6 8.5 9.7 7.7 10.2 7.2C10.7 6.8 11.4 6.8 11.9 7.2L10.1 9ZM18.3 9.5C17.8 8.8 17.2 8.1 16.5 7.6L15.5 8.6C16.3 9.2 17 9.9 17.6 10.8C15.9 13.4 13 15 9.9 15H9.1L8.1 16C8.8 15.9 9.4 16 10 16C13.3 16 16.4 14.4 18.3 11.7C18.6 11.3 18.8 10.9 19.1 10.5C18.8 10.2 18.6 9.8 18.3 9.5ZM14 10L10 14C12.2 14 14 12.2 14 10Z" fill="#111111"/>
</svg>`;

  var $password = $('.woocommerce-checkout #password');

  if ($password.length) {
    $password.wrap('<div class="password-input"></div>');
    $password.find('input').addClass('woocommerce-Input woocommerce-Input--password input-text');
  }

  // WISHLIST COURS FAVORIS
  function getWishlist() {
    if (typeof penegaFavorites !== 'undefined' && Array.isArray(penegaFavorites.productIds)) {
      return penegaFavorites.productIds.map(Number);
    }

    return JSON.parse(localStorage.getItem('wishlistProducts') || '[]');
  }

  function saveWishlist(ids) {
    if (typeof penegaFavorites !== 'undefined') {
      penegaFavorites.productIds = ids;
    }

    localStorage.setItem('wishlistProducts', JSON.stringify(ids));
  }

  function renderWishlistCounter(count) {
    var $menuFav = $('.menu-favorites');
    var $counter = $menuFav.find('.favorites-count');

    if (count <= 0) {
      $counter.remove();
    } else {
      if (!$counter.length) {
        $menuFav.append('<span class="favorites-count">' + count + '</span>');
      } else {
        $counter.text(count);
      }
    }
  }

  function refreshWishlistCounter() {
    if (typeof penegaFavorites === 'undefined' || !penegaFavorites.ajaxUrl) {
      return;
    }

    $.ajax({
      url: penegaFavorites.ajaxUrl,
      type: 'POST',
      data: {
        action: 'update_favorites_count'
      },
      success: function (response) {
        var $menuFav = $('.menu-favorites');

        $menuFav.find('.favorites-count').remove();

        if (response) {
          $menuFav.append(response);
        }
      }
    });
  }

  function updateWishlistProduct(productId, action) {
    if (typeof wbte_wishlist_ajax_add === 'undefined' || !wbte_wishlist_ajax_add.add_to_wishlist) {
      return $.Deferred().reject().promise();
    }

    return $.ajax({
      url: wbte_wishlist_ajax_add.add_to_wishlist,
      type: 'POST',
      data: {
        action: 'add_to_wishlist',
        product_id: productId,
        act: action,
        quantity: 1,
        wt_nonce: wbte_wishlist_ajax_add.wt_nonce
      }
    });
  }

  function updateWishlistCounterFromPlugin() {
    var $rows = $('.wt_frontend_wishlist_table tbody tr.wishlist-row');

    if (!$rows.length) {
      return;
    }

    renderWishlistCounter($rows.length);
  }

  // Run on page load
  updateWishlistCounterFromPlugin();
  refreshWishlistCounter();

  function syncWishlistHearts() {
    var wishlist = getWishlist();

    $('.wishlist-heart').each(function () {
      var id = parseInt($(this).data('product-id'));
      if (wishlist.includes(id)) {
        $(this).addClass('hearted');
      } else {
        $(this).removeClass('hearted');
      }
    });
  }

  $(document).on('penega:formations-updated', syncWishlistHearts);

  var $table = $('.wt_frontend_wishlist_table tbody');
  var isWishlistPage = $table.length > 0;

  if ($table.length) {
    var $grid = $('<div class="cours-favoris"></div>');

    $table.find('tr.wishlist-row').each(function () {
      var $tr = $(this);
      var $titleCell = $tr.find('td:nth-child(3) a');
      var productId = $tr.find('.remove_wishlist_single').data('product_id');
      var $thumbnail = $tr.find('td:nth-child(2) img').first();
      var thumbnailSrc = $thumbnail.attr('data-full') || $thumbnail.attr('src') || '';

      if (!productId || !$titleCell.length) {
        return;
      }

      if (thumbnailSrc) {
        thumbnailSrc = thumbnailSrc.replace('-100x100', '');
      }

      var $card = $('<div class="single-box single-post" style="--bg-color: #39AFE1;"></div>');
      var $inner = $('<div class="inner"></div>');
      var $imgDiv = $('<div class="img"></div>');

      if (thumbnailSrc) {
        var $img = $('<img>', {
          src: thumbnailSrc,
          alt: $titleCell.text()
        });
        $imgDiv.append($img);
      }

      var $content = $('<div class="content"></div>');

      if ($titleCell.length) {
        var $link = $('<a href="' + $titleCell.attr('href') + '"></a>')
          .attr('data-product-id', productId);

        var $h2 = $('<h2 class="text-white"></h2>')
          .text($titleCell.text());

        $link.append($h2);
        $content.append($link);
      }

      var $actions = $('<div class="d-flex align-items-center justify-content-between"></div>');

      if ($titleCell.length) {
        var $btn = $('<a class="btn btn-primary" href="' + $titleCell.attr('href') + '">Voir</a>');
        $actions.append($btn);
      }

      var $heart = $(`
            <div class="wishlist-heart" data-product-id="${productId}">
                <svg width="23" height="21" viewBox="0 0 23 21" fill="#FCBC12" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L3.67129 11.4518L11.4513 19.2318L19.2313 11.4518L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z"
                        stroke="#FCBC12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `);

      $actions.append($heart);
      $content.append($actions);
      $inner.append($imgDiv).append($content);
      $card.append($inner);
      $grid.append($card);
    });

    if ($grid.children().length) {
      $table.closest('form').html($grid);
      syncWishlistHearts();
      renderWishlistCounter($grid.children().length);
    }
  }

  $(document).on('click', '.wishlist-heart', function (e) {
    var $heart = $(this);
    var productId = $heart.data('product-id');

    if (isWishlistPage) {
      e.preventDefault();

      updateWishlistProduct(productId, 'remove').done(function () {
        $heart.closest('.single-box').fadeOut(function () {
          $(this).remove();
          renderWishlistCounter($('.cours-favoris .single-box').length);
        });

        saveWishlist(getWishlist().filter(function (id) {
          return id !== parseInt(productId, 10);
        }));
        refreshWishlistCounter();
      });

      return;
    }

    var productIdInt = parseInt(productId, 10);
    var isHearted = $heart.hasClass('hearted');
    var nextAction = isHearted ? 'remove' : 'add';

    updateWishlistProduct(productIdInt, nextAction).done(function () {
      var wishlist = getWishlist().filter(function (id) {
        return id !== productIdInt;
      });

      if (nextAction === 'add') {
        wishlist.push(productIdInt);
      }

      saveWishlist(wishlist);
      $('.wishlist-heart[data-product-id="' + productIdInt + '"]').toggleClass('hearted', nextAction === 'add');
      refreshWishlistCounter();
    });

    // update counter
    setTimeout(function () {
      updateWishlistCounterFromPlugin();
      refreshWishlistCounter();
    }, 300);
  });

  // Cart quantity click
  let updateCartTimer = null;

  $(document).on('click', '.woocommerce-cart-form .quantity', function (e) {
    const $quantity = $(this);
    const $input = $quantity.find('input.qty');

    if (!$input.length) return;

    const offset = $quantity.offset();
    const x = e.pageX - offset.left;
    const width = $quantity.outerWidth();

    const input = $input.get(0);

    if (x < 24) {
      input.stepDown();
    } else if (x > width - 24) {
      input.stepUp();
    } else {
      return;
    }

    $input.trigger('input').trigger('change');

    clearTimeout(updateCartTimer);

    updateCartTimer = setTimeout(function () {
      const $updateBtn = $('button[name="update_cart"]');

      $updateBtn
        .prop('disabled', false)
        .removeAttr('disabled')
        .attr('aria-disabled', 'false');

      $updateBtn.trigger('click');
    }, 300);
  });

  setTimeout(function () {
    $('.woocommerce-checkout .woocommerce-form-login-toggle .e-show-login').trigger('click');
  }, 500);

  // Achat de groupe
  $('.wdm_seats').each(function () {
    const $seats = $(this);
    const $enrolled = $seats.find('.wdm_seats_enrolled_users');
    const $available = $seats.find('.wdm_seats_available');

    // Remove the original text while keeping Edwiser's number spans.
    $seats.contents().filter(function () {
      return this.nodeType === 3;
    }).remove();

    $enrolled.before('<span class="wdm-enrolled-label"></span>');
    $enrolled.after('<span class="wdm-enrolled-text"></span>');
    $available.before('<span class="wdm-separator"> / </span>');
    $available.after('<span class="wdm-available-text"></span>');

    function updateLabels() {
      const enrolled = parseInt($.trim($enrolled.text()), 10) || 0;
      const available = parseInt($.trim($available.text()), 10) || 0;

      $seats.find('.wdm-enrolled-label').text('');
      $seats.find('.wdm-enrolled-text').text(
        enrolled <= 1
          ? ' utilisateur inscrit'
          : ' utilisateurs inscrits'
      );

      $seats.find('.wdm-available-text').text(
        available <= 1
          ? ' place disponible'
          : ' places disponibles'
      );
    }

    updateLabels();

    const observer = new MutationObserver(updateLabels);

    observer.observe($enrolled[0], {
      childList: true,
      subtree: true,
      characterData: true
    });

    observer.observe($available[0], {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
});

var getUrlParameter = function (sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
